module.exports = __webpack_public_path__ + "132ce2f46af452e07f79d350d31c3f3f.png";